/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
const o=.1,t=.001;export{o as defaultMaskAlphaCutoff,t as symbolAlphaCutoff};
